import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
import ScriptChoose from '@/gikam/js/components/template/fields/scriptChoose.vue';
import { mapState } from 'vuex';
export default {
  components: {
    ScriptChoose: ScriptChoose
  },
  provide: {
    grid: function grid() {
      return null;
    }
  },
  props: {
    options: Object,
    propValue: String,
    validateArg: Object,
    dataId: [Number, String]
  },
  computed: _objectSpread({}, mapState(['form'])),
  mounted: function mounted() {
    this.form.editorManager[this.options.field] = this.$refs.editor;
  },
  methods: {
    changeHandle: function changeHandle() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['change'].concat(args));
    },
    afterChooseHandle: function afterChooseHandle() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['afterChoose'].concat(args));
    }
  }
};